var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-table',_vm._b({on:{"actionTriggered":_vm.handleAction}},'data-table',_vm.parametersTable1,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }